import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { OWF_OPENING_YEAR_OPTIONS } from "@faire/web-api--source/indigofair/settings/OWF_OPENING_YEAR_OPTIONS";

export const getSettingOwFOpeningYearOptions = () =>
  getSettingValueWithoutAssignment(OWF_OPENING_YEAR_OPTIONS, [
    IRetailer.ReportedCreationTime.OPENING_SOON,
    IRetailer.ReportedCreationTime.STARTED_THIS_YEAR,
    IRetailer.ReportedCreationTime.STARTED_ONE_YEAR_AGO,
    IRetailer.ReportedCreationTime.STARTED_BETWEEN_5_AND_2_YEAR_AGO,
    IRetailer.ReportedCreationTime.BEFORE_5_YEAR_AGO,
  ]);
